<template>
  <el-dialog
    class="dialog"
    title="名单管理"
    width="50%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
    @close="close"
  >
    <div>
      <div class="left-panel">
        <el-input
          size="small"
          v-model="query"
          prefix-icon="el-icon-search"
          placeholder="请输入学员姓名"
          @input="queryMember"
        ></el-input>
        <el-tree
          class="member-tree"
          ref="memberTree"
          show-checkbox
          node-key="id"
          :data="memberData"
          default-expand-all
          :default-expanded-keys="checkData"
          :props="{ children: 'children', label: 'name' }"
          @check-change="checkAction"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
      <div class="right-panel">
        <div class="panel-header">
          <span>已选中{{ selectedMembers.length }}人</span>
          <el-button
            type="text"
            :disabled="selectedMembers.length == 0"
            @click="clear"
            >清空
          </el-button>
        </div>
        <ul class="member-list">
          <li v-for="(member, index) in selectedMembers" :key="member.id">
            <div>
              <span>{{ member.name }}</span>
              <i
                class="el-icon-close"
                v-bind:style="[member.disabled ? disabledStyle : enableStyle]"
                @click="deleteMember(index)"
              ></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { treeUserForClass } from "@/api/enrollment";
import { saveEnroll, getEnrollList, getEnrolledList } from "@/api/enrollment";

export default {
  data() {
    return {
      dialogVisible: false,
      query: "",
      classId: "",
      disabledStyle: {
        display: "none"
      },
      enableStyle: {
        float: "right",
        cursor: "pointer"
      },
      memberData: [],
      checkData: [],
      selectedMembers: []
    };
  },
  created() {
    vue.$on("selectMember", classId => {
      this.dialogVisible = true;
      this.classId = classId;
      this.getEnrolledList();
      this.getMembers();
    });
  },
  methods: {
    // 获取名单树
    getMembers() {
      treeUserForClass(this.classId).then(res => {
        if (!res || res.code != 0) return;
        this.memberData = res.data;
        this.getEnrollList();
        if (this.checkData.length > 0) {
          this.memberData = this.disableRecursive(this.memberData);
        }

        if (this.selectedMembers.length > 0) {
          this.$refs["memberTree"].setCheckedKeys(
            this.selectedMembers.map(ele => ele.id)
          );
        }
      });
    },
    // 已报名的学员列表（用于报名回显）
    getEnrollList() {
      getEnrollList(this.classId).then(res => {
        if (!res || res.code != 0) return;
        let successMembers = res.data;
        if (successMembers.length > 0) {
          this.$refs["memberTree"].setCheckedKeys(successMembers);
        }
      });
    },
    // 已报名送审的学员列表（用于报名回显禁用）
    getEnrolledList() {
      getEnrolledList(this.classId).then(res => {
        if (!res || res.code != 0) return;
        this.checkData = res.data;
      });
    },

    //递归方法设置元素禁用
    disableRecursive(children) {
      return children.map(item => {
        if (this.checkData.some(check => check == item.id)) {
          item.disabled = true;
        }
        if (item.children && item.children.length > 0) {
          item.children = this.disableRecursive(item.children);
        }
        return item;
      });
    },
    checkAction() {
      // 获取所有选中的叶子节点
      const array = this.$refs["memberTree"].getCheckedNodes(true);
      this.selectedMembers = array.filter(ele => ele.type == 1);
    },
    // 搜索考试成员
    queryMember(val) {
      this.$refs.memberTree.filter(val);
    },
    // 清空
    clear() {
      this.selectedMembers = this.selectedMembers.filter(
        item => item.disabled == true
      );
      this.$refs["memberTree"].setCheckedNodes(this.selectedMembers);
    },
    // 删除选中人员
    deleteMember(index) {
      if (!this.selectedMembers[index].disabled) {
        this.selectedMembers.splice(index, 1);
      }
      this.$refs["memberTree"].setCheckedNodes(this.selectedMembers);
    },
    // 搜索符合条件的考试人员，只搜索人员
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1 && data.type == 1;
    },
    // dialog关闭时重置状态
    close() {
      this.selectedMembers = [];
      this.$refs["memberTree"].setCheckedNodes([]);
    },
    confirm() {
      if (this.selectedMembers.length === 0) {
        this.$message({
          message: "请选择学员",
          type: "warning"
        });
      } else {
        saveEnroll({
          classId: this.classId,
          userIdList: this.selectedMembers.map(ele => ele.id)
        }).then(res => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "新增成功",
            type: "success"
          });
          this.dialogVisible = false;
          vue.$emit("tableInit");
        });
      }
    }
  },
  beforeDestroy() {
    vue.$off("selectMember");
  }
};
</script>

<style lang="scss" scoped>
$text-color: #51627d;
$text-font: 14px;
@mixin text {
  color: $text-color;
  font-size: $text-font;
}

@mixin border {
  border: 1px solid #d7dbe0;
  border-radius: 2px;
}

@mixin panel {
  width: 48%;
  height: 300px;
  box-sizing: border-box;
  overflow: hidden;
}

.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;

    .left-panel {
      float: left;
      @include border;
      padding: 10px;
      @include panel;
    }

    .right-panel {
      float: right;
      @include border;
      @include panel;
    }

    .member-tree {
      margin-top: 10px;
      height: calc(100% - 42px);
      overflow-y: auto;

      /deep/ .el-tree-node__label {
        @include text;
      }
    }

    .panel-header {
      background-color: #f2f3f4;
      height: 44px;
      display: flex;
      padding: 0 15px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      & > span:first-child {
        @include text;
      }
    }

    .member-list {
      height: calc(100% - 64px);
      overflow-y: auto;
      margin: 10px 0;
      padding: 0 10px;

      li {
        list-style: none;
        padding: 8px 10px;
        @include text;

        &:hover {
          background-color: #3a85ff;
          color: #fff;
        }
      }
    }
  }
}
</style>
